import { useZero } from "@rocicorp/zero/react";
import { useState } from "react";
import { sharedMutators } from "../../../shared/mutators";
import { useHasAccess } from "../../hooks/useHasAccess";
import { Button } from "../Button";
import { EmptyState } from "../EmptyState";
import { useToast } from "../Toast";

export function DraftStorageEmptyState({
  spaceId,
  branchId,
  liveHasVolumes,
}: {
  spaceId: string;
  branchId: string;
  liveHasVolumes: boolean;
}) {
  const z = useZero();
  const canWrite = useHasAccess("space:write", spaceId);
  const { showToast } = useToast();
  const [copying, setCopying] = useState(false);

  const copy = () => {
    setCopying(true);
    void z
      .mutate(sharedMutators.seedBranchVolumes({ branchId, from: "live" }))
      .server.then((result) => {
        setCopying(false);
        if (result.type === "error") {
          showToast({
            icon: "circle-off",
            message: result.error.message,
            buttonLabel: "Dismiss",
          });
        }
      });
  };

  return (
    <EmptyState
      iconName="box"
      title="No stored data in this draft yet"
      description={
        liveHasVolumes
          ? "Drafts start with empty storage, so this draft can behave differently from live until it has data of its own. Copy live’s data to test against it."
          : "Drafts start with empty storage. Files this draft reads and writes will appear here."
      }
      action={
        liveHasVolumes && canWrite ? (
          <Button
            variant="secondary"
            icon="copy"
            disabled={copying}
            onClick={copy}
          >
            Copy data from live
          </Button>
        ) : undefined
      }
    />
  );
}
